import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import IsCstService from 'business/cadastro/fiscal/isCst/isCstService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabPanel, TabView } from 'primereact/tabview'

export default function IsCst() {

    const [service] = useState(() => new IsCstService())
    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(schema => {
            setValidations(schema)
        })
    }, [service])

    return (
        <FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-4" field="descricao_iscst" form={form} service={service} type="text" clearString label="Descrição" />

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
